/**
 * Dependências externas
 */
import React from 'react';
import { connect as connectToFormik } from 'formik';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Textarea
} from '@chakra-ui/core';

/**
 * Dependências internas
 */
import getInformacoesDoCampo from '../../../../../utils/form/getInformacoesDoCampo';

const Observacao = props => {
  const nomeDoCampo = 'observacao';

  const { formik, ...rest } = props;

  const { handleChange, handleBlur } = formik;

  const { valor = false, erro, possuiErroDeValidacao } = getInformacoesDoCampo(
    props,
    nomeDoCampo
  );

  return (
    <FormControl isInvalid={possuiErroDeValidacao} {...rest}>
      <FormLabel htmlFor={nomeDoCampo}>Observação</FormLabel>
      <Textarea
        type="text"
        id={nomeDoCampo}
        name={nomeDoCampo}
        onChange={handleChange}
        onBlur={handleBlur}
        value={valor}
        autoComplete="off"
      />
      {possuiErroDeValidacao && <FormErrorMessage>{erro}</FormErrorMessage>}
    </FormControl>
  );
};

export default connectToFormik(Observacao);
